import { Box, Stack, useTheme } from "@mui/material";
import { FoodsTooltip, Typography } from "@foodpilot/foods";
import type { AuditLogAction } from "src/api/client-api/auditLog/auditLogSchemas";
import { useAuditLogLabels } from "./useAuditLogLabels";

type ActionIndicatorProps = {
    action: AuditLogAction;
};

const Dot = (props: ActionIndicatorProps) => {
    const { action } = props;
    const theme = useTheme();

    const colors: Record<AuditLogAction, string> = {
        create: theme.palette.success.main,
        update: theme.palette.warning.main,
        delete: theme.palette.error.main,
    };

    return (
        <Box
            sx={{
                width: theme.spacing(1),
                height: theme.spacing(1),
                borderRadius: "50%",
                backgroundColor: colors[action],
                flexShrink: 0,
            }}
        />
    );
};

export const ActionDot = (props: ActionIndicatorProps) => {
    const { action } = props;
    const labels = useAuditLogLabels();

    return (
        <FoodsTooltip title={labels.action(action)}>
            <Stack justifyContent="center" flexShrink={0}>
                <Dot action={action} />
            </Stack>
        </FoodsTooltip>
    );
};

export const ActionIndicator = (props: ActionIndicatorProps) => {
    const { action } = props;
    const theme = useTheme();
    const labels = useAuditLogLabels();

    return (
        <Stack direction="row" gap={theme.spacing(1)} alignItems="center" overflow="hidden">
            <Dot action={action} />
            <Typography variant="small-medium" noWrap>
                {labels.action(action)}
            </Typography>
        </Stack>
    );
};
